import { Form, Input, Button, Select, Typography, Layout, Row, Col, Checkbox, InputNumber, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { createAgent, deleteAgent, updateAgent, updateAgentActiveStatus, getAgents } from '../../actions/agents.actions';
import { generatePassword, isValid, isValidArrayWithValues, isValidBool } from '../../utils/utilities';
import { showConfirm } from './../custom-components/custom-component';
import { POST_PAID_USER, PRE_PAID_USER } from '../../utils/constant';


const { Option } = Select;
const { Content, Footer } = Layout;
const { Title, Text } = Typography;

export const AgentForm = (props) => {
  
    const [form] = Form.useForm();
    const [showPassword, setShowPassword] = useState(false);
    const [lastCommissionValue, setLastCommissionValue] = useState(null);
    const [lastCommissionType, setLastCommissionType] = useState(null);

    const dispatch = useDispatch();

    const {
        formData,
        updateformData,
        agentPrivilieges,
        branchOffices,
        selectedOperatorCode,
        agents
    } = { ...props };

    const isSubAgentOrSubUser = (privilege) => privilege === 'Sub Agent' || privilege === 'Sub User';

    let operatorCode = isValid(selectedOperatorCode) ? selectedOperatorCode : global.operatorCode;
    let defaultPostFixUserName = "-" + (operatorCode || '');
    const [agentType, setAgentType] = useState(null);

    const getAgentsPoints = () => {
        dispatch(getAgents(false, false, () => { }, () => { }, isValid(selectedOperatorCode) ? selectedOperatorCode : undefined, true));
    }

    const onSuccess = (data) => {
      message.success(data.Message);
      getAgentsPoints();
      onReset();
    }

    const onFailure = (error) => {
      message.error(error);
    }

    const onReset = () => {
        updateformData({});
        setAgentType(null);
    };

    const printOptionBranch = (option) => {
        return <Option value={option.name}>{option.name}</Option>
    };

    const handleSubmit = (e, buttonType) => {
        e.preventDefault();
        form.validateFields()
            .then(values => {
                let {
                    acCommissionType,
                    commissionType,
                    hitechCommissionType,
                    location,
                    name,
                    password,
                    phone_number,
                    privilege,
                    user_name,
                    agent_type,
                    cancellation_penality_percentage,
                    verify_otp_for_login,
                    discount_percentage,
                    discount_value,
                    branch,
                    nonAcCommissionInclGst,
                    acCommissionInclGst,
                    hiTechCommissionInclGst,
                    master_agent_id
                } = values;

                const toNumberIfPresent = (v) => (v != null && v !== '' ? Number(v) : v);
                nonAcCommissionInclGst = toNumberIfPresent(nonAcCommissionInclGst);
                acCommissionInclGst = toNumberIfPresent(acCommissionInclGst);
                hiTechCommissionInclGst = toNumberIfPresent(hiTechCommissionInclGst);

                let formateData = {
                    name: name,
                    location: location,
                    password: password,
                    phone_number: phone_number,
                    privilege: privilege,
                    user_name: user_name,
                    agent_type: agent_type,
                    verify_otp_for_login: verify_otp_for_login,
                    cancellation_penality_percentage,
                    discount_percentage: discount_percentage,
                    discount_value: discount_value,
                    branch: branch,
                    master_agent_id: isSubAgentOrSubUser(privilege) ? (master_agent_id || null) : null
                };

                if (isValid(acCommissionType) && acCommissionType == "%") {
                    formateData.ac_commission = 0
                    formateData.ac_commission_percentage = acCommissionInclGst;
                } else {
                    formateData.ac_commission = acCommissionInclGst;
                    formateData.ac_commission_percentage = 0;
                }
                if (isValid(hitechCommissionType) && hitechCommissionType == "%") {
                    formateData.hitech_commission = 0;
                    formateData.hitech_commission_percentage = hiTechCommissionInclGst;
                } else {
                    formateData.hitech_commission = hiTechCommissionInclGst;
                    formateData.hitech_commission_percentage = 0;
                }
                if (isValid(commissionType) && commissionType == "%") {
                    formateData.commission = 0;
                    formateData.commission_percentage = nonAcCommissionInclGst;
                } else {
                    formateData.commission = nonAcCommissionInclGst;
                    formateData.commission_percentage = 0;
                }

                formateData.operator_code = operatorCode;

                if (buttonType == 'add') {
                    formateData.user_name = formateData.user_name + defaultPostFixUserName;
                    createAgent({ ...formateData, operatorCode, operator_code: operatorCode }, onSuccess, onFailure);
                } else if (buttonType = "update") {
                    formateData.id = formData.id;
                    updateAgent({ ...formateData, operatorCode, operator_code: operatorCode }, onSuccess, onFailure);
                }
            })
            .catch(errorInfo => {
                console.log({ errorInfo });
            })
    };

    const handleGeneratePassword = () => {
        form.setFieldsValue({
            password: generatePassword(10)
        })
    }

    useEffect(() => {
        fillForm()
        if (isValid(formData) && isValidBool(formData.show_password)) {
            setShowPassword(formData.show_password);
        } else {
            setShowPassword(true);
        }
    }, [formData])

    const fillForm = () => {
        if (isValid(formData)) {
            let {
                ac_commission,
                ac_commission_percentage,
                access_code,
                commission,
                commission_percentage,
                encrypted_password,
                hitech_commission,
                hitech_commission_percentage,
                location,
                name,
                password,
                phone_number,
                privilege,
                user_name,
                website_commission,
                website_commission_percentage,
                agent_type,
                cancellation_penality_percentage,
                verify_otp_for_login,
                discount_percentage,
                discount_value,
                branch,
                master_agent_id
            } = formData;
            let commissionType = null, acCommissionType = null, hitechCommissionType = null,
                nonAcCommission = null, acCommission = null, hiTechCommission = null,
                nonAcCommissionInclGst = null, acCommissionInclGst = null, hiTechCommissionInclGst = null;
            if (commission >= 1 || (commission == 0 && (commission_percentage < 0 || !isValid(commission_percentage)))) {
                commissionType = '₹';
                nonAcCommission = commission;
                nonAcCommissionInclGst = commission;
            } else if (commission_percentage >= 0) {
                commissionType = '%';
                nonAcCommission = commission_percentage
                nonAcCommissionInclGst = commission_percentage;
            }
            if (ac_commission >= 1 || (ac_commission == 0 && (ac_commission_percentage < 0 || !isValid(ac_commission_percentage)))) {
                acCommissionType = "₹";
                acCommission = ac_commission;
                acCommissionInclGst = ac_commission;
            } else if (ac_commission_percentage >= 0) {
                acCommissionType = "%";
                acCommission = ac_commission_percentage;
                acCommissionInclGst = ac_commission_percentage;
            }

            if (!isValid(verify_otp_for_login)) {
                verify_otp_for_login = false;
            }

            if (hitech_commission >= 1 || (hitech_commission == 0 && (hitech_commission_percentage < 0 || !isValid(hitech_commission_percentage)))) {
                hitechCommissionType = "₹";
                hiTechCommission = hitech_commission;
                hiTechCommissionInclGst = hitech_commission;
            } else if (hitech_commission_percentage >= 0) {
                hitechCommissionType = "%";
                hiTechCommission = hitech_commission_percentage;
                hiTechCommissionInclGst = hitech_commission_percentage;
            }
            form.setFieldsValue({
                ac_commission: ac_commission,
                ac_commission_percentage: ac_commission_percentage,
                access_code: access_code,
                nonAcCommissionInclGst: nonAcCommissionInclGst,
                acCommissionInclGst: acCommissionInclGst,
                hiTechCommissionInclGst: hiTechCommissionInclGst,
                commission_percentage: commission_percentage,
                encrypted_password: encrypted_password,
                hitech_commission: hitech_commission,
                hitech_commission_percentage: hitech_commission_percentage,
                location: location,
                name: name,
                password: password,
                phone_number: phone_number,
                privilege: privilege,
                user_name: user_name,
                website_commission: website_commission,
                website_commission_percentage: website_commission_percentage,
                acCommissionType: acCommissionType,
                commissionType: commissionType,
                hitechCommissionType: hitechCommissionType,
                agent_type: agent_type,
                cancellation_penality_percentage: cancellation_penality_percentage,
                verify_otp_for_login: verify_otp_for_login,
                discount_percentage: discount_percentage,
                discount_value: discount_value,
                branch: branch,
                master_agent_id: master_agent_id
            })
            setAgentType(privilege);
        } else {
            form.resetFields();
        }
    }

    const deleteAction = () => {
        showConfirm(
            () => {
                deleteAgent(formData.id, onSuccess, onFailure, operatorCode);
            },
            'Delete Agent',
            'Are you sure you want to delete this agent?'
        )
    }

    /* Selected user is in-active only when the row explicitly says so */
    let isSelectedUserActive = !(formData.is_active == false || formData.is_active == 0);

    const activeStatusAction = () => {
        /* In-active user is activated back, active user is made in-active */
        let updatedIsActive = !isSelectedUserActive;
        showConfirm(
            () => {
                updateAgentActiveStatus(formData.id, updatedIsActive, onSuccess, onFailure);
            },
            updatedIsActive ? 'Activate User' : 'In-activate User',
            updatedIsActive ? 'Are you sure you want to activate this user?'
                : 'Are you sure you want to make this user inactive?'
        )
    }

    let isRowClicked = isValid(formData) && isValid(formData.id) ? true : false;
    let isCommissionManditory = isValid(agentType) && (agentType == "Booking Agent" || agentType === "Agent BT") ? true : false;

    const printOptionPrivilege = (option) => {
        return <Option value={option.privilege}>{option.privilege}</Option>
    };

    return (
        <Layout>
            <Title level={4}>Users/Agents Form</Title>
            <Content>
                <Form
                    form={form}
                    name="basic"
                    initialValues={{ cancellation_penality_percentage: 0, verify_otp_for_login: false, agent_type: null }}
                    className="form"
                    autoComplete="off"
                >
                    {/* Hidden dummy fields to stop Chrome from autofilling the
                        real username/password below with the logged-in user's
                        saved credentials. */}
                    <input type="text" name="fake-username" autoComplete="username" style={{display:'none'}} />
                    <input type="password" name="fake-password" autoComplete="current-password" style={{display:'none'}} />
                    <Row>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Name"
                                name="name"
                                rules={[{ required: true, message: 'Please input your name!' }]}
                            >
                                <Input placeholder="Name" />
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Type"
                                name="privilege"
                                rules={[{ required: true, message: 'Please input your type!' }]}
                            >
                                <Select
                                    showSearch
                                    width={200}
                                    placeholder="Select type"
                                    onChange={(data) => {
                                        setAgentType(data);
                                        if(!isSubAgentOrSubUser(data)){
                                            form.setFieldsValue({ master_agent_id: undefined });
                                        }
                                    }}
                                >
                                  {agentPrivilieges
                                    .filter(item => item.privilege !== 'Driver')
                                    .map(printOptionPrivilege)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Location"
                                name="location"
                                rules={[{ required: false, message: 'Please input your location!' }]}
                            >
                                <Input placeholder="Location" />
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Branch"
                                name="branch"
                                rules={[{ required: false, message: 'Please select your branch!' }]}
                                hidden={!isValidArrayWithValues(branchOffices)}
                            >
                                <Select placeholder="Select branch">
                                    {branchOffices.map(printOptionBranch)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Phone No"
                                name="phone_number"
                                rules={[{ required: true, message: 'Please input your phone no!' }]}
                            >
                                <Input placeholder="Phone no" />
                            </Form.Item>
                        </Col>
                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 5, offset: 1 }}
                            lg={{ span: 5 }}
                            hidden={!isSubAgentOrSubUser(agentType)}
                        >
                            <Form.Item
                                label="Master Agent"
                                name="master_agent_id"
                                rules={[{ required: isSubAgentOrSubUser(agentType), message: 'Please select master agent!' }]}
                                hidden={!isSubAgentOrSubUser(agentType)}
                            >
                                <Select
                                    showSearch
                                    allowClear
                                    style={{ width: 200 }}
                                    dropdownMatchSelectWidth={false}
                                    placeholder="Select master agent"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.children ?? '').toLowerCase().includes((input || '').toLowerCase())
                                    }
                                >
                                    {isValidArrayWithValues(agents) && agents
                                        .filter((a) => !isSubAgentOrSubUser(a.privilege) && (!isValid(formData) || a.id !== formData.id))
                                        .map((a) => (
                                            <Option value={a.id} key={a.id} title={a.name}>{a.name}</Option>
                                        ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="User Name"
                                name="user_name"
                                rules={[{ required: true, message: 'Please input your user name!' }]}
                            >
                                <Input
                                    disabled={isRowClicked}
                                    placeholder="User name"
                                    addonAfter={isRowClicked ? null : defaultPostFixUserName}
                                    autoComplete="off"
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Password"
                                name="password"
                                rules={[{ required: false, message: 'Please input your password!' }]}
                            >
                                <Input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    disabled={showPassword ? false : true}
                                    autoComplete="new-password"
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item>
                                <Button 
                                    disabled={showPassword ? false : true}
                                    type="danger" 
                                    onClick={handleGeneratePassword}
                                >
                                    Generate password
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                                <Form.Item
                                    label="Agent type"
                                    name="agent_type"
                                    rules={[{ required: false, message: 'Please input your agent type!' }]}
                                >
                                    <Select 
                                        showSearch
                                        width={60}
                                        placeholder="Select agent type"
                                    >
                                        <Option value={null}></Option>
                                        <Option value={POST_PAID_USER}>Post-paid</Option>
                                        <Option value={PRE_PAID_USER}>Pre-paid</Option>
                                    </Select> 
                                </Form.Item> 
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}> 
                            <Form.Item
                                label="Cancellation penality %"
                                name="cancellation_penality_percentage"
                                rules={[{ required: false, message: 'Please input your cancellation penality %!' }]}
                            >
                                <InputNumber placeholder='Cancellation penality %'/> 
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Discount percentage"
                                name="discount_percentage"
                                rules={[{ required: false, message: 'Please input your discount percentage!' }]}
                            >
                                <InputNumber placeholder='Discount %'/>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Discount value"
                                name="discount_value"
                                rules={[{ required: false, message: 'Please input your discount value!' }]}
                            >
                                <InputNumber placeholder='₹'/>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                valuePropName="checked"
                                label="Verify OTP for Login"
                                name="verify_otp_for_login"
                                rules={[{ required: false, message: 'Please input your Verify OTP for Login!' }]}
                            >
                                <Checkbox />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row> 
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Text strong> Commission(Incl. GST)</Text>
                            <span style={{marginLeft:10}}>
                                <Text>Copy Commission</Text>
                                <Checkbox style={{ marginLeft: '10px' }} onChange={(e) => {
                                    if (e.target.checked) {
                                        form.setFieldsValue({
                                            commissionType: lastCommissionType,
                                            acCommissionType: lastCommissionType,
                                            hitechCommissionType: lastCommissionType,
                                            nonAcCommissionInclGst: lastCommissionValue,
                                            acCommissionInclGst: lastCommissionValue,
                                            hiTechCommissionInclGst: lastCommissionValue,
                                        });
                                    }
                                }} />
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={{ span: 10, offset: 1 }} sm={{ span: 10, offset: 1 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Non A/C"
                                name="nonAcCommissionInclGst"
                                rules={[{ required: isCommissionManditory, message: '' }]}
                            >
                                <Input onChange={(e) => {
                                    setLastCommissionValue(e.target.value);
                                }} />
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 10, offset: 1 }} sm={{ span: 10, offset: 1 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Commission Type"
                                name="commissionType"
                                rules={[{ required: isCommissionManditory, message: '' }]}
                            >
                                <Select 
                                    showSearch
                                    width={100}
                                    placeholder="Select"
                                    onChange={(value) => {
                                        setLastCommissionType(value);
                                    }}
                                >
                                    <Option value={"₹"}>₹</Option>
                                    <Option value={"%"}>%</Option>
                                </Select> 
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={{ span: 10, offset: 1 }} sm={{ span: 10, offset: 1 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="A/C"
                                name="acCommissionInclGst"
                                rules={[{ required: isCommissionManditory, message: '' }]}
                            >
                                <Input onChange={(e) => {
                                    setLastCommissionValue(e.target.value);
                                }} />
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 10, offset: 1 }} sm={{ span: 10, offset: 1 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Commission Type"
                                name="acCommissionType"
                                rules={[{ required: isCommissionManditory, message: '' }]}
                            >
                                <Select 
                                    showSearch
                                    width={100}
                                    placeholder="Select"
                                    onChange={(value) => {
                                        setLastCommissionType(value);
                                    }}
                                >
                                    <Option value={"₹"}>₹</Option>
                                    <Option value={"%"}>%</Option>
                                </Select> 
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={{ span: 10, offset: 1 }} sm={{ span: 10, offset: 1 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Scania/Volvo"
                                name="hiTechCommissionInclGst"
                                rules={[{ required: isCommissionManditory, message: '' }]}
                            >
                                <Input onChange={(e) => {
                                    setLastCommissionValue(e.target.value);
                                }} />
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 10, offset: 1 }} sm={{ span: 10, offset: 1 }} md={{ span: 5, offset: 1 }} lg={{ span: 5 }}>
                            <Form.Item
                                label="Commission Type"
                                name="hitechCommissionType"
                                rules={[{ required: isCommissionManditory, message: '' }]}
                            >
                                <Select      
                                    width={100}
                                    showSearch
                                    placeholder="Select"
                                    onChange={(value) => {
                                        setLastCommissionType(value);
                                    }}
                                >
                                    <Option value={"₹"}>₹</Option>
                                    <Option value={"%"}>%</Option>
                                </Select> 
                            </Form.Item>
                        </Col>
                    </Row>                                  
                </Form>
            </Content>
            <Footer style={{ textAlign: 'center' }} type="flex">
                <Row type="flex" justify="space-around">
                    <Button
                        style={{ margin: '5px', background: '#2EC17C' }}
                        disabled={isRowClicked}
                        onClick={(e) => {
                            handleSubmit(e, 'add');
                        }}>
                        <Text>Add</Text>
                    </Button>
                    <Button type="primary"
                        style={{ margin: '5px' }}
                        onClick={(e) => {
                            handleSubmit(e, 'update');
                        }}>
                        Update
                    </Button>
                    <Button
                        style={{ margin: '5px' }}
                        disabled={!isRowClicked}
                        onClick={activeStatusAction}>
                        {isSelectedUserActive ? 'Inactive' : 'Activate'}
                    </Button>
                    <Button type="danger"
                        style={{ margin: '5px' }}
                        disabled={!isRowClicked}
                        onClick={deleteAction}>
                        Delete
                    </Button>
                    <Button type="block"
                        style={{ margin: '5px' }}
                        onClick={() => {
                            updateformData({});
                        }}>
                        Clear
                    </Button>
                </Row>
            </Footer>
        </Layout>
    );
}
